// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"ec3a9110","488":"2843876f"}[chunkId] + ".chunk.js";
};